import { getPrefix } from "@Rocket-Innovation/components/utilities/getPrefix";
import { PROD, UAT } from "src/Configs/blockingList";
import { getDeployEnvironment } from "./getDeployEnvironment";

export default function checkBlockMerchant() {
    const environment = getDeployEnvironment();
    const prefix = getPrefix();
    if (environment === "production" && PROD.some((domain) => prefix === domain)) {
        window.location.replace("/");
        return true;
    }
    if (
        (environment === "preview" || environment === "development") &&
        UAT.some((domain) => prefix === domain)
    ) {
        window.location.replace("/");
        return true;
    }
    return false;
}
